<mat-sidenav-container class="container">
  <mat-sidenav mode="side" opened>
    <div class="sidebar">
      <!-- Admin Menu -->
      <mat-nav-list *ngIf="isAdmin">
        <mat-list-item routerLink="/home" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-house-user"></i>
            Home
          </div>
        </mat-list-item>
        <mat-list-item routerLink="/sales/generaldash" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-chart-line"></i>
            Sales
          </div>
        </mat-list-item>
        <mat-list-item routerLink="/files" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-folder-tree"></i>
            File Library
          </div>
        </mat-list-item>
        <mat-list-item routerLink="/sales/storesdash" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-building"></i>
            Stores
          </div>
        </mat-list-item>
        <mat-list-item routerLink="/products" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-box-open"></i>
            Products
          </div>
        </mat-list-item>
        <mat-list-item routerLink="/suppliers" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-truck"></i>
            Suppliers
          </div>
        </mat-list-item>
        
        <!-- Attendance Section -->
        <mat-list-item routerLink="/attendance" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-fingerprint"></i>
            Attendance
          </div>
        </mat-list-item>
        
        <mat-list-item routerLink="#" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-users"></i>
            People
          </div>
        </mat-list-item>
        <mat-list-item routerLink="#" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-camera"></i>
            Camera
          </div>
        </mat-list-item>
        <mat-list-item routerLink="#" routerLinkActive="active" *ngIf="readRecordRoles">
          <div class="sidebar-item">
            <i class="fas fa-bars"></i>
            Misc
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Attendance User Menu -->
      <mat-nav-list *ngIf="isAttendanceUser">
        <mat-list-item routerLink="/attendance" routerLinkActive="active">
          <div class="sidebar-item">
            <i class="fas fa-fingerprint"></i>
            Attendance Management
          </div>
        </mat-list-item>
      </mat-nav-list>
      <!-- <mat-expansion-panel *ngIf="isAdmin">
        <mat-expansion-panel-header *ngIf="readRecordRoles">
          <img src="./assets/images/properties.png" alt="property menu" />Sales
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/sales/generaldash" routerLinkActive="active" *ngIf="readRecordRoles"><i
            class="fa fa-fw fa-search"></i>Overall</a>
            <a mat-list-item routerLink="/sales/generaldashsearchrange" routerLinkActive="active" *ngIf="readRecordRoles"><i
              class="fa fa-fw fa-search"></i>Search Range</a>
          <a mat-list-item routerLink="/sales/timesheetdash" routerLinkActive="active" *ngIf="readRecordRoles"><i
            class="fa fa-fw fa-search"></i>TimeSheet</a>
          <a mat-list-item routerLink="/sales/list" routerLinkActive="active" *ngIf="readRecordRoles"><i
              class="fa fa-fw fa-search"></i>Import</a>
        </mat-nav-list>
      </mat-expansion-panel> -->
      <!-- <mat-expansion-panel>
        <mat-expansion-panel-header *ngIf="isAdmin">
          <img src="./assets/images/properties.png" alt="property menu" />Creams
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/sales/creamsdash" routerLinkActive="active" *ngIf="readRecordRoles"><i
            class="fa fa-fw fa-search"></i>Creams</a>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header *ngIf="isAdmin">
          <img src="./assets/images/properties.png" alt="property menu" />MH
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/sales/mhdash" routerLinkActive="active" *ngIf="readRecordRoles"><i
            class="fa fa-fw fa-search"></i>MH</a>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header *ngIf="isAdmin">
          <img src="./assets/images/properties.png" alt="property menu" />DISHD
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="#" routerLinkActive="active" *ngIf="readRecordRoles"><i
            class="fa fa-fw fa-search"></i>DISHD</a>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header class="menu-item" *ngIf="readRecordRoles">
          <img src="./assets/images/people.png" alt="people menu" />Stock
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/products/list" routerLinkActive="active" *ngIf="readRecordRoles"><i
              class="fa fa-fw fa-search"></i>List Stock</a>
          <a mat-list-item routerLink="/products/stockcount" routerLinkActive="active" *ngIf="readRecordRoles"><i
            class="fa fa-fw fa-search"></i>Stock Count</a>
          <a mat-list-item routerLink="/products/stockcountbatch" routerLinkActive="active" *ngIf="readRecordRoles"><i
            class="fa fa-fw fa-search"></i>Stock Count Batch</a>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header class="menu-item" *ngIf="isAdmin">
          <img src="./assets/images/billing.png" alt="billing sub-menu" />Suppliers
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/supplier/list" routerLinkActive="active" *ngIf="readRecordRoles"><i
              class="fa fa-fw fa-search"></i>List Suppliers</a>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header *ngIf="isAdmin">
          <img src="./assets/images/properties.png" alt="property menu" />People
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="#" routerLinkActive="active" *ngIf="readRecordRoles"><i
              class="fa fa-fw fa-search"></i>List People</a>
        </mat-nav-list>
      </mat-expansion-panel>   
      <mat-expansion-panel>
        <mat-expansion-panel-header class="menu-item" *ngIf="isAdmin">
          <img src="./assets/images/organisations.png" alt="organisation sub-menu" />Cameras
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="#" routerLinkActive="active" *ngIf="readRecordRoles"><i
              class="fa fa-fw fa-search"></i>List Cameras</a>
        </mat-nav-list>
      </mat-expansion-panel> -->
      <!-- <mat-expansion-panel>
        <mat-expansion-panel-header class="menu-item" *ngIf="readRecordRoles">
          <img src="./assets/images/organisations.png" alt="organisation sub-menu" />BuyIns
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/buyin/list" routerLinkActive="active" *ngIf="readRecordRoles"><i
              class="fa fa-fw fa-search"></i>List BuyIns</a>
        </mat-nav-list>
      </mat-expansion-panel> -->

      <!-- <mat-expansion-panel>
        <mat-expansion-panel-header class="menu-item" *ngIf="isAdmin">
          <img src="./assets/images/billing.png" alt="billing sub-menu" />Users
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/user/list" routerLinkActive="active" *ngIf="readRecordRoles"><i
              class="fa fa-fw fa-search"></i>List
            Users</a>
        </mat-nav-list>
      </mat-expansion-panel>
      
      <mat-expansion-panel>
        <mat-expansion-panel-header class="menu-item" *ngIf="isAdmin">
          <img src="./assets/images/organisations.png" alt="organisation sub-menu" />Misc
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/files" routerLinkActive="active" *ngIf="readRecordRoles"><i
            class="fa fa-fw fa-search"></i>Files</a>
          <a mat-list-item routerLink="#" routerLinkActive="active" *ngIf="readRecordRoles"><i
              class="fa fa-fw fa-search"></i>List Misc</a>
        </mat-nav-list>
      </mat-expansion-panel> -->
    </div>
  </mat-sidenav>
</mat-sidenav-container>
